import * as React from "react";
import {createRef, FC, JSX, useEffect, useState} from "react";
// import MapContainer from "../UI/Map/MapContainer";
import { useParams } from 'react-router';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';
import classes2 from '../../pages/Search/Search.module.css';
// @ts-ignore TODO ts-ignore
import { Theme } from '../styles/styles.js';
// @ts-ignore TODO ts-ignore
import useHttp from '../CustomHooks/use-http.js';
// @ts-ignore TODO ts-ignore
import { getUrl } from '../../requests.js';
import Avatar from "@mui/material/Avatar";
import { IconButton, Modal, useMediaQuery } from "@mui/material";
// @ts-ignore TODO ts-ignore
import { GoodMapCard } from '../GoodMapCard/GoodMapCard.js';
// @ts-ignore TODO ts-ignore
import ModalMap from '../UI/ModalMap/ModalMap.js';
// @ts-ignore TODO ts-ignore
import { GoodMapCardHeader } from '../../GoodMapCardHeader/GoodMapCardHeader.js';
import { useAuth0 } from "@auth0/auth0-react";
// @ts-ignore TODO ts-ignore
import { MessageBox } from '../Lokalni2/MessageBox.js';
import { Helmet } from 'react-helmet-async';
// @ts-ignore TODO ts-ignore
import {GoodDetailsCard} from '../GoodDescriptionCard/GoodDetailsCard.tsx';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import axios from "axios";
// @ts-ignore TODO ts-ignore
import { ContactMailForm } from '../Lokalni2/ContactMailForm.js';
import clsx from "clsx";
import css from "./MapOfGood.module.css";
// @ts-ignore TODO ts-ignore
import MapContainer from '../UI/Map/MapContainer.js';
import {GoodDetailsCardBuilder} from "../Model/GoodDetailsCard.ts";
import {GoodDetailsBuilder, GoodDetailsRec} from "../Model/GoodDetails.ts";
interface MapOfGoodProps {
  apikey: string;
  sessionid: string;
}

const MapOfGoods: FC<MapOfGoodProps> = (props): JSX.Element => {
  console.log("MapOfGoodProps",props);

  const { name, id } = useParams();
  // @ts-ignore TODO ts-ignore
  const { isLoading, error, sendRequest: fetchData } = useHttp();
  const [searchResults, setSearchResults] = useState([]);
  // @ts-ignore TODO ts-ignore
  const [searchAddress, setSearchAddress] = useState("");
  const [pointsOfGood, setpointsOfGood] = useState([]);
  const [placeYouAreLookingFor, setplaceYouAreLookingFor] = useState({});
  // @ts-ignore TODO ts-ignore
  const [localStatus, setLocalStatus] = useState(null);
  const [lat, setLat] = useState();
  const [lon, setLon] = useState();
  const [refs, setRefs] = useState([]);
  const [modalMapIsShown, setModalMapIsShown] = useState(false);


  // @ts-ignore TODO ts-ignore
  const [myLoading, setMyLoading] = useState();
  // @ts-ignore TODO ts-ignore
  const [httpError, setHttpError] = useState(null);
  // @ts-ignore TODO ts-ignore
  const {
    isAuthenticated,
    handleRedirectCallback,
      // @ts-ignore TOD ts-ignore
    getTokenSilently,
      // @ts-ignore TOD ts-ignore
    getUser,
    loginWithPopup,
  } = useAuth0();

  // @ts-ignore TODO ts-ignore
  const city = localStorage.getItem("city");

  const placeID = localStorage.getItem("placeID");


  const navigate = useNavigate();


  const handleChange = () => {
    setModalMapIsShown((prev) => !prev);
  };

  const [isOpenGoodDetailsModal, setIsOpenGoodDetailModal] = useState(false);

  // @ts-ignore TODO ts-ignore
  const [currentGoodDetail, setCurrentGoodDetail] = useState<GoodDetailsRec>({...GoodDetailsBuilder.rec().build()});

  const setNext = () => {
    setCurrentIndex((prev) => {
      if (prev < searchResults.length - 1) {
        return prev + 1;
      }
      return prev;
    });

  };

  const setPrevious = () => {
    setCurrentIndex((prev) => {
      if (prev > 0) {
        return prev - 1;

      }
      return prev;
    });

  };

  const handleCloseGoodDetailsModal = () => setIsOpenGoodDetailModal(false);

  const [isOpenContactMailForm, setIsOpenContactMailForm] = useState(false);
  const handleOpenContactMailForm = () => {
    handleCloseGoodDetailsModal();
    setIsOpenContactMailForm(true)
  };

  const handleCloseContactMailForm = () => {
    setIsOpenContactMailForm(false);
    setIsOpenGoodDetailModal(true);
  }

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const myrefs = searchResults.reduce((acc, value) => {
      // @ts-ignore TODO ts-ignore
      acc[value.id] = createRef();
      return acc;
    }, {});
    // @ts-ignore TODO ts-ignore
    setRefs(myrefs);

  }, [searchResults]);

  useEffect(() => {
    // @ts-ignore TODO ts-ignore
    const tmpCurrentGoodDetail = { currentIndex, ...searchResults[currentIndex] };

    setCurrentGoodDetail(tmpCurrentGoodDetail);

  }, [currentIndex]);

  useEffect(() => {
    // @ts-ignore TODO ts-ignore
    const enteredSearchHandler = (data) => {
      if (data.totalResults === 0) {
        // @ts-ignore TODO ts-ignore
        setLocalStatus(`Przepraszamy, nie mogliśmy znaleźć wyniku dla ${name}`);
        setSearchResults([]);
      } else {
        setSearchResults(data.pointsOfGood);
        setSearchAddress(data.placeYouAreLookingFor.addressSearch);
        setpointsOfGood(data.pointsOfGood);
        setplaceYouAreLookingFor(data.placeYouAreLookingFor);

        setLat(
          data.placeYouAreLookingFor.geographicCoordinates.latitude.toFixed(4)
        );
        setLon(
          data.placeYouAreLookingFor.geographicCoordinates.longitude.toFixed(4)
        );
        setLocalStatus(null);

      }
    };
    let respose = "";
    const fetchDetails = async () => {
      if (placeID) {
        // @ts-ignore TODO ts-ignore
        respose = await fetch(
          `${getUrl()}/api/v1/rfs/byPlaceId?placeId=${id}&sessionId=${encodeURIComponent(
              props.sessionid
          )}`
        );
        console.log("respose",respose);
        // @ts-ignore TODO ts-ignore
        setMyLoading(false);
      } else {

        const lat = localStorage.getItem("lat");
        const lng = localStorage.getItem("lng");
        // @ts-ignore TODO ts-ignore
        respose = await fetch(`${getUrl()}/api/v1/rfs`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "*/*",
          },
          body: JSON.stringify({
            geographicCoordinates: {
              latitude: lat,
              longitude: lng,
            },
          }),
        });
        console.log("respose",respose);
      }
      // @ts-ignore TODO ts-ignore
      if (!respose.ok) {
        // @ts-ignore TODO ts-ignore
        throw new Error(`Błąd! ${respose.status}`);
      }
      // @ts-ignore TODO ts-ignore
      const responceData = await respose.json();
      enteredSearchHandler(responceData);
      console.log("responceData",responceData);
    };


    // @ts-ignore TODO ts-ignore
    setMyLoading(false);
    setHttpError(null);
    try {
      // @ts-ignore TODO ts-ignore
      setMyLoading(true);
      fetchDetails().catch((err) => {
        // @ts-ignore TODO ts-ignore
        setHttpError(`Brak danych, ${err.message ? err : "Wystąpił niezidentyfikowany problem"}`
        );
        // @ts-ignore TODO ts-ignore
        setMyLoading(false);
        // @ts-ignore TODO ts-ignore
        setLocalStatus(`Przepraszamy, nie mogliśmy znaleźć wyniku dla ${name}`);
      });
    } catch (error) {
      // @ts-ignore TODO ts-ignore
      setMyLoading(false);
      // @ts-ignore TODO ts-ignore
      setHttpError(`Nie znaleziono danych, ${error.message}`);
    }
    // @ts-ignore TODO ts-ignore
    setMyLoading(false);
  }, [name, id]);
  //fetchData,lat,lon,props.city
  // @ts-ignore TODO ts-ignore
  const ourMediaQuerymax = useMediaQuery("only screen and (max-width:1279px)");
  const appCont = document.querySelector("#appcontainer");
  if (appCont) {
    appCont.className = "MapContainer";
  }
  // @ts-ignore TODO ts-ignore
  const redirectToDetailsHandler = async (el) => {
    setCurrentGoodDetail(el);
    setIsOpenGoodDetailModal(true);
    setCurrentIndex(el.i)

  };
  // @ts-ignore TODO ts-ignore
  function setNativeValue(el, value) {
    const previousValue = el.value;
    el.value = value;
    const tracker = el._valueTracker;
    if (tracker) {
      tracker.setValue(previousValue);
    }
    el.dispatchEvent(new Event("input", { bubbles: true }));
  }

  const mapStyles = {
    height: "85vh",
    width: "60vw",
    borderTopLeftRadius: "0px",
    borderBottomLeftRadius: "0px",
    borderTopRightRadius: "24px",
    borderBottomRightRadius: "24px"

  };
  // @ts-ignore TODO ts-ignore
  const postEmailForm = (topic, emailText, emailFrom) => {

    const body = {
      topic: topic,
      body: emailText,
      emailFrom: emailFrom
    }
    // @ts-ignore TODO ts-ignore
    axios.post(`${getUrl()}/api/v1/profile/${currentGoodDetail.profileId}/message`, body)
        // @ts-ignore TODO ts-ignore
        .then(function (response) {

          handleCloseContactMailForm();
        })
        .catch(function (error) {
          console.log(error);
        });

  }

  // @ts-ignore
  return (
    <Box sx={{
       mt: "95px",
       height:"100vh",
      ml:"10%",
      mr:"10%"


    }}>
      <Helmet >
        <title>Mapa dobra
        </title>
        <meta name="description" content=" Mapa dobra - Informacje o działaniach charytatywnych oraz akcjach społecznych w twojej okolicy" />
      </Helmet>

      <Box className={clsx(css.mapOfGoods)} height="100vh" alignSelf="center" justifySelf="center">
        <h1 style={{ display: 'none' }}>Mapa dobra - działania charytatywne w twojej okolicy</h1>
        {searchResults.length > 0 && !modalMapIsShown && (
          <Box
            sx={{
              width: "100%",
              [Theme.breakpoints.down("laptop")]: {

              },
              [Theme.breakpoints.up("laptop")]: {
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "flex-start",

              },
            }}
          >


              <GoodMapCard
                goodMapItems={searchResults}
                redirectToDetailsHandler={redirectToDetailsHandler}
                references={refs}
                onClick={handleChange}

              />


            <Box sx={{
              position: "relative", width: "100%", height: "100%",
              [Theme.breakpoints.down("laptop")]: {
                display: "none",
              },

            }}>

              <MapContainer
                lat={lat}
                lon={lon}
                companies={searchResults}
                points={pointsOfGood}
                references={refs}
                apikey={props.apikey ? props.apikey : localStorage.getItem("ApiKey")}
                mapStyles={mapStyles}
              />

            </Box>
            <Box  >
              {/*@ts-ignore TODO ts-ignore*/}
              <Modal id="goodDetailsModal"
                open={isOpenGoodDetailsModal}
                onClose={handleCloseGoodDetailsModal}
                slotProps={{
                  backdrop: {
                    invisible: true,
                  },
                }}
                disableBackdropClick={true}
                disableEscapeKeyDown={true}
              >
                <Box id="goodDetails"
                  sx={{

                    position: "fixed",
                    backgroundColor: "#transparent",
                    display: "flex",
                    flexDirection: "column",
                    border: "none",

                    boxShadow: "none",
                    outline: "none",
                    margin: "0 auto",
                    padding: "0",

                    [Theme.breakpoints.down("tablet")]: {
                      overflow: "auto",
                      height: "70vh",

                      top: "50%",
                      left: "50%",
                      width: "92vw",
                      transform: "translate(-50%, -50%)"
                    },

                    [Theme.breakpoints.up("tablet")]: {

                      top: "35%",
                      left: "49%",

                      transform: "translate(-50%, -50%)",

                    },

                    [Theme.breakpoints.up("laptop")]: {

                      top: "35%",
                      left: "53%",
                      transform: "translate(-50%, -50%)",
                      width: "34.5vw",

                    },

                    [Theme.breakpoints.up("desktop")]: {

                      top: "35%",
                      left: "63%",
                      transform: "translate(-50%, -50%)",
                      width: "44vw",

                    },

                    [Theme.breakpoints.up("bigscreen")]: {

                      top: "35%",
                      left: "63.5%",
                      transform: "translate(-50%, -50%)",

                    },
                  }}
                >

                  <GoodDetailsCard
                      {...GoodDetailsCardBuilder
                          .rec()
                          .fromGoodDetailsRec(currentGoodDetail)
                          .companyDescription(
                              currentGoodDetail.companyInformation?.length > 450
                                ? currentGoodDetail.companyInformation.slice(0, 450) + '...'
                                : currentGoodDetail.companyInformation
                          )
                          .companyInfoOnClickButtonAction(handleOpenContactMailForm)
                          .handleCloseGoodDetailsModal(handleCloseGoodDetailsModal)
                          .build()
                      }
                  />
                  <Box sx={{ display: "flex", justifyContent: "center", mt: -3, }}>
                    <IconButton sx={{color: "red"}} onClick={handleCloseGoodDetailsModal}>

                      <Avatar sx={{ bgcolor: "#f29a26", width: 27, height: 27, mr: "6px" }}>
                        <CloseIcon
                          sx={{
                            fontSize: 24,
                            color: "#fff",
                          }}
                        />
                      </Avatar>

                    </IconButton>

                    <IconButton onClick={setPrevious} disabled={currentIndex === 0}>
                      <Avatar sx={{ bgcolor: "#fff", width: 24, height: 24, mr: "6px" }}>
                        <KeyboardArrowLeftIcon
                          sx={{
                            fontSize: 32,
                           color: "#000",
                          }}
                        />
                      </Avatar>
                    </IconButton>
                    <IconButton onClick={setNext} disabled={currentIndex === searchResults.length - 1}>
                      <Avatar sx={{ bgcolor: "#fff", width: 24, height: 24, mr: "6px" }}>
                        <KeyboardArrowRightIcon
                          sx={{
                            fontSize: 32,
                            color: "#000",
                          }}
                        />
                      </Avatar>
                    </IconButton>

                  </Box>
                </Box>
              </Modal>
              <Modal
                open={isOpenContactMailForm}
                onClose={handleCloseContactMailForm}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"

              >
                <Box
                  sx={{
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    position: "absolute",
                    //width:"50vw",
                    bgcolor: "lightblue",
                    borderRadius: "16px",


                  }}
                >
                  <ContactMailForm onCancel={handleCloseContactMailForm} onSaveButton={postEmailForm} />
                </Box>
              </Modal>

            </Box>

          </Box>
        )}


        {modalMapIsShown && (
          <ModalMap onClose={handleChange}>
            <GoodMapCardHeader />
            <Box id="slider-screen" className={classes2.mapcontainer__container}>
              <MapContainer
                lat={lat}
                lon={lon}
                companies={searchResults}
                points={pointsOfGood}
                apikey={props.apikey}
                references={refs}
                place={{
                  // @ts-ignore TODO ts-ignore
                  geographicCoordinates: placeYouAreLookingFor.geographicCoordinates,
                  // @ts-ignore TODO ts-ignore
                  companyName: placeYouAreLookingFor.addressSearch,
                }}
                mapStyles={mapStyles}
              />
            </Box>
          </ModalMap>
        )}
        {(searchResults.length === 0 || !searchResults) &&
          localStorage.getItem("geolocation") === "true" && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "44px",
              }}
            >
              <MessageBox
                headerText="Brak danych o dobrach"
                info="Nie istnieją żadne dobra w podanej lokalizacji !!"
                onNextButton={() => navigate(`/szukaj`)}
              />
            </Box>
          )}

        {localStorage.getItem("geolocation") === "false" && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "44px",
            }}
          >
            <MessageBox
              headerText="Wyłączona geolokalizacja"
              info="Nie można wyświetlić strony z uwagi na fakt, że masz wyłączoną usługe geolokalizacji w przeglądarce !!"
              onNextButton={() => navigate(`/szukaj`)}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};
export default MapOfGoods;
